/* global bocAmchart */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValetDateAsSeries = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValetDateAsSeries(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 *  Produces and returns an array of data based on the valet response,
 *  uses date points as series, and series labels as text categories
 *
 * @param {object} data Object containing the valet data sets
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValetDateAsSeries = function (data, dataLoader, chart) {
    var output = [];
    var observationsBySeries = {},
        allDates = [],
        property;

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running doPostProcessValetDateAsSeries, input data:",
            data
        );
    }

    data.observations.forEach(function (set) {
        var dateSet = [];
        var date;
        for (property in set) {
            if (set.hasOwnProperty(property)) {
                if (property === 'd') {
                    date = set.d;
                    if (allDates.indexOf(date) === -1) {
                        allDates.push(date);
                    }
                } else {
                    dateSet[property] = set[property].v;
                }
            }
        }

        for (property in dateSet) {
            if (dateSet.hasOwnProperty(property)) {
                if (!observationsBySeries.hasOwnProperty(property)) {
                    var label = data.seriesDetail[property].label;
                    observationsBySeries[property] = {'category': label};
                }
                observationsBySeries[property][date] = set[property].v;
            }
        }
    });

    for (property in data.seriesDetail) {
        if (observationsBySeries.hasOwnProperty(property)) {
            output.push(observationsBySeries[property]);
        }
    }

    chart.graphs = [];

    var balloonFunction = bocAmchart.defaultDate;

    if (chart.bocSettings.args.hasOwnProperty("period")) {
        switch (chart.bocSettings.args.period) {
            case "month":
                balloonFunction = bocAmchart.monthlyFunction;
                break;
            case "quarter":
                balloonFunction = bocAmchart.quarterFunction;
                break;
            case "year":
                balloonFunction = bocAmchart.annualFunction;
                break;
        }
    }

    allDates.forEach(function (date) {
        bocAmchart.addGraph(
            chart,
            date,
            balloonFunction(new Date(date))
        );
    });

    bocAmchart.getChartTitlesFromGroup(data, chart);

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "After doPostProcessValet, output:",
            output
        );
    }

    return output;
};

